<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Empresas" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras los datos de los empresas registrados." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0">
          <div style="width: 286px;">
            <v-text-field
              v-model="busqueda"
              placeholder="Buscar empresa"
              clearable
              hide-details
              outlined
              style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
              prepend-inner-icon="mdi-magnify"
            />
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" :disabled="!canCreateEnterprise" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dialogCreateEnterprise = true">
            {{ "Crear empresa" }}
          </v-btn>
          <v-btn color="#000000" :disabled="true" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="filteredItems">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>                                                                                                                                      
              <th class="header__title left">{{ "Nombre" }}</th>         
              <th class="header__title center">{{ "Divisas" }}</th>  
              <th class="header__title center">{{ "Factoraje Cedente" }}</th>  
              <th class="header__title center">{{ "Factoraje Deudor" }}</th>  
              <th class="header__title center">{{ "Credito Revolvente" }}</th>  
              <th class="header__title right">{{ "Acciones" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sName }}</td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.divisasStatus == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.divisasStatus }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.cedente == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.cedente }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.deudor == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.deudor }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.creditoRevolvente == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.creditoRevolvente }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :disabled="true" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar comprobante</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="filteredItems">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd; ">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Nombre" }}</div>
                <div>{{ item.sName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Email" }}</div>
                <div>{{ item.sEmail }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Empresa" }}</div>
                <div>{{ item.sEnterpriseName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Credits" }}</div>
                <div>{{ item.creditos }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Activo" }}</div>
                <div>
                  <v-chip
                    class="ma-2"
                    :color="item.active == 'Active' ? 'green' : 'red'"
                    outlined
                  >
                    {{ item.active }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acceso Plataforma" }}</div>
                <div>
                  <v-chip
                    class="ma-2"
                    :color="item.bPlatformAccess == 'Active' ? 'green' : 'red'"
                    outlined
                  >
                    {{ item.bPlatformAccess }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acciones" }}</div>
                <div>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="true" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalle</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>

    <!-- Dialog Crear Empresa -->
    <v-dialog v-model="dialogCreateEnterprise" v-if="dialogCreateEnterprise" max-width="500px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 500px">
          <v-card-title
            class="pa-0"
            style="display: flex; text-align: center; justify-content: center;"
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Crear empresa" }}
            </span>
          </v-card-title>
          <v-card-text class="py-6 px-4">
            <v-form ref="enterpriseForm" autocomplete="off">
              <v-row>
                <!-- Nombre de la empresa -->
                <v-col cols="12">
                  <v-text-field
                    label="Nombre de la empresa *"
                    v-model="newEnterpriseName"
                    :rules="[rules.required]"
                    hide-details="auto"
                    style="font-family: 'montserrat-medium'; border-radius: 20px;"
                    outlined
                    clearable
                    class="mb-4"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-5" style="justify-content: space-evenly">
            <v-btn
              elevation="4"
              class="mr-2 px-10"
              style="
                color: black;
                border-radius: 36px;
                border: 2px solid black;
                background-color: #fff;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              outlined
              :disabled="isLoadingEnterprise"
              @click="closeCreateDialog()"
            >
              {{ "Cancelar" }}
            </v-btn>
            <v-btn
              color="black"
              elevation="4"
              class="white--text px-10"
              style="
                border-radius: 36px;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              :disabled="isLoadingEnterprise || !isFormValid"
              :loading="isLoadingEnterprise"
              @click="createEnterprise()"
            >
              {{ "Crear" }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import { saveAs } from "file-saver";
  import * as XLSX from "xlsx";
  import { mapGetters } from "vuex";

  export default {
    name: "DashboardView",
    data() {
      return {
        items: [],
        busqueda: "",
        loading: false,
        nameXLSX: "",
        dialogCreateEnterprise: false,
        newEnterpriseName: "",
        isLoadingEnterprise: false,
        rules: {
          required: v => !!v || 'Campo requerido',
        }
      };
    },
    methods: {
      getUsers() {
        this.loading = true;
        this.items = [];
        DB.get(`${URI}/api/v1/en/administrator/allEnterprises`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          this.loading = false;
          this.items = response.data.results.map((item) => {
            return {
              sName: item.sName,
              divisasStatus: item.divisasStatus == 'activo' ? "Active" : "Inactive",
              cedente: item.factoraje?.cedente == 'activo' ? "Active" : "Inactive",
              deudor: item.factoraje?.deudor == 'activo' ? "Active" : "Inactive",
              creditoRevolvente: item.creditoRevolvente == 'activo' ? "Active" : "Inactive",
              originalItem: item,
            };
          });
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      dataXLSX() {
        try {
          let data = this.items.map((item) => {
            return {
              Name: item.sName,
              Divisas: item.divisasStatus == 'activo' ? "Active" : "Inactive",
              Cedente: item.factoraje?.cedente == 'activo' ? "Active" : "Inactive",
              Deudor: item.factoraje?.deudor == 'activo' ? "Active" : "Inactive",
            };
          });
          const worksheet = XLSX.utils.json_to_sheet(data);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

          const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const date = moment().format("YYYY-MM-DD HH:mm");
          this.nameXLSX = `Wallets_${date}.xlsx`;
          saveAs(blob, this.nameXLSX);
          this.success = true;
          this.msgSuccess = "Descargando documento";
        } catch (error) {
          this.error = true;
          this.codeError = "CSV_NO_DATA";
        }
      },
      createEnterprise() {
        if (!this.$refs.enterpriseForm.validate()) {
          return;
        }

        this.isLoadingEnterprise = true;

        const payload = {
          newEnterpriseName: this.newEnterpriseName.trim(),
        };

        DB.post(`${URI}/api/v1/en/administrator/createEnterpriseOnly`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.isLoadingEnterprise = false;
          this.mixSuccess("Empresa creada correctamente");
          this.closeCreateDialog();
          this.getUsers();
        })
        .catch((error) => {
          this.isLoadingEnterprise = false;
          if (error.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(
            error.response?.data?.message || "Error al crear la empresa",
            error.response?.status
          );
        });
      },
      closeCreateDialog() {
        this.dialogCreateEnterprise = false;
        this.newEnterpriseName = "";
        if (this.$refs.enterpriseForm) {
          this.$refs.enterpriseForm.resetValidation();
        }
      }
    },
    computed: {
      ...mapGetters(['hasPermission']),
      canCreateEnterprise() {
        return this.hasPermission('66723287-3ada-40a2-832c-f0a94d6507b0');
      },
      filteredItems() {
        if (!this.busqueda) return this.items;

        const texto = this.busqueda.toLowerCase();
        return this.items.filter(item => {
          const nombre = item.sName?.toLowerCase() || "";

          return (
            nombre.includes(texto)
          );
        });
      },
      isFormValid() {
        return (
          this.newEnterpriseName &&
          this.newEnterpriseName.trim() !== ''
        );
      }
    },
    beforeMount() {
      this.getUsers();
    },
  };
</script>

<style>
</style>
